import { cva } from 'class-variance-authority';

export const fileUploadLabelVariants = cva(
  [
    'p-spacing-comp-file-upload-vertical',
    'border',
    'border-dashed',
    'rounded-radius-comp-file-upload',
    'border-color-comp-file-upload-outline-default',
    'block',
    'p-spacing-comp-file-upload-vertical',
    'flex',
    'flex-col',
    'gap-spacing-comp-file-upload-content-gap',
    'items-center',
    'text-center',
    'text-color-comp-file-upload-text-default',
    'cursor-pointer',
    // hover
    'hover:border-color-comp-file-upload-outline-hover',
    'hover:text-color-comp-file-upload-text-hover',
    'hover:text-color-comp-file-upload-icon-hover [&>svg]:fill-current',
    // focused
    'focus-visible:outline-none',
    'focus-visible:border-color-comp-file-upload-outline-focused',
    'focus-visible:text-color-comp-file-upload-text-focused',
    'focus-visible:text-color-comp-file-upload-icon-focused [&>svg]:fill-current',
    // disabled
    'aria-disabled:border-color-comp-file-upload-outline-disabled',
    'aria-disabled:text-color-comp-file-upload-icon-disabled [&>svg]:fill-current',
    'aria-disabled:cursor-not-allowed',
  ],
  {
    variants: {
      isActive: {
        true: [
          'border-color-comp-file-upload-outline-active',
          'text-color-comp-file-upload-text-active',
          'text-color-comp-file-upload-icon-active [&>svg]:fill-current',
        ],
        false: [],
      },
      hasError: {
        true: [
          'border-color-comp-file-upload-outline-error',
          'text-color-comp-file-upload-text-active',
          'text-color-comp-file-upload-icon-active [&>svg]:fill-current',
        ],
        false: [],
      },
    },
    defaultVariants: {
      isActive: false,
      hasError: false,
    },
  },
);
